import classNames from "classnames";
import isString from "lodash/isString";
import { Pill } from "PFComponents/pill";
import { PropsWithChildren } from "react";

import css from "./element_pill.module.scss";

type ElementPillProps = {
  highlighted?: boolean;
  noWrap?: boolean;
  title?: string;
};

export const ElementPill = ({
  highlighted,
  noWrap,
  title,
  children
}: PropsWithChildren<ElementPillProps>) => {
  const ChildrenWrapper = highlighted && isString(children) ? "strong" : "span";

  return (
    <Pill
      kind={highlighted ? "general" : "ghost"}
      clipOverflowText={false}
      title={title}
      classes={{ root: classNames(css.elementPill, { [css.noWrap]: noWrap }), text: css.content }}
      small
    >
      <ChildrenWrapper>{children || "-"}</ChildrenWrapper>
    </Pill>
  );
};
